import imgWelton81 from "./img-welton8 (1).webp";
import imgWelton82 from "./img-welton8 (2).webp";
import imgWelton83 from "./img-welton8 (3).webp";
import imgWelton84 from "./img-welton8 (4).webp";

const imgWelton8 = [imgWelton81, imgWelton82, imgWelton83, imgWelton84];

export default imgWelton8;
